//@flow
export const YES_ANSWER='yesAnswer'
export const NO_ANSWER='noAnswer'
export const YES = 'Yes'
export const NO = 'No'


// WEBPACK FOOTER //
// ./src/Utils/variables.js